import { Controller } from '@hotwired/stimulus'
import 'emoji-picker-element'

export default class extends Controller {
  static targets = ['input', 'form']

  select(event) {
    this.inputTarget.value = event.detail.unicode
    this.formTarget.requestSubmit()
  }
}